import { Component } from '@theme/component';
import { QuantitySelectorUpdateEvent } from '@theme/events';

/**
 * @typedef {Object} Refs
 * @property {HTMLSelectElement} quantitySelect
 *
 * @extends {Component<Refs>}
 */
class QuantitySelectorComponent extends Component {
  /**
   * Handles quantity selection.
   * @param {Event} event
   */
  setQuantity(event) {
    if (!(event.target instanceof HTMLSelectElement)) return;

    const newValue = parseInt(event.target.value, 10);
    this.#dispatchQuantityChange(newValue);
  }

  /**
   * Dispatches custom update event
   * @param {number} newValue
   */
  #dispatchQuantityChange(newValue) {
    const { quantitySelect } = this.refs;

    quantitySelect.dispatchEvent(
      new QuantitySelectorUpdateEvent(newValue, Number(quantitySelect.dataset.cartLine))
    );
  }

  /**
   * Getter for select element
   */
  get quantitySelect() {
    if (!this.refs.quantitySelect) {
      throw new Error('Missing <select ref="quantitySelect" /> inside <quantity-selector-component />');
    }
    return this.refs.quantitySelect;
  }
}

if (!customElements.get('quantity-selector-component')) {
  customElements.define('quantity-selector-component', QuantitySelectorComponent);
}
